import styled from "styled-components";
export const SettingWrap = styled.div`
  padding: 20px;
  background-color: #fff;
  border-radius: 15px;
  box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.11);
  min-height: 600px;
  align-items: center;
  position: relative;
  @media (min-width: 1199px) {
    display: grid;
    grid-template-columns: 350px 1fr;
    gap: 30px;
  }
  .left-content {
    padding: 0 10px;
    border-right: 1px solid #dcdcdc;
    height: 100%;
    position: sticky;
    width: 100%;
    transition: all 0.4s ease-in-out;
    @media (min-width: 1199px) {
      padding-right: 10px;
    }
    @media (max-width: 1199px) {
      padding: 20px 10px;
      max-width: 320px;
      position: absolute;
      top: 0px;
      left: -100%;
      z-index: 1;
      background: var(--white);
      background-color: #fff;
      border-radius: 15px;
      box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.11);
      border-right: none;
      height: 600px;
      overflow-y: auto;
    }
    .activeSettingSideBar & {
      left: 0;
    }
    .tabs-wrap {
      .tab {
        cursor: pointer;
        display: flex;
        justify-content: space-between;
        align-items: center;
        gap: 10px;
        padding: 20px 0;
        border-bottom: 1px solid #dcdcdc;
        color: #313131;
        transition: all 0.3s ease;
        svg {
          color: #313131;
          width: 20px;
          height: 20px;
        }
        strong {
          font-size: 16px;
          line-height: 20px;
          font-weight: 400;
        }
        &:nth-last-child(1) {
          border-bottom: none;
        }
      }
      .tab strong.active {
        color: ${({ theme }) => theme?.light?.primary};
      }
    }
    .profile-wrap {
      text-align: center;
      margin-bottom: 20px;
      font-size: 16px;
      line-height: 20px;
      color: #707070;
      .title {
        font-weight: 500;
        color: #343434;
        margin-bottom: 5px;
        display: block;
      }
      .image-wrap {
        margin: 0 auto 15px;
        width: 100px;
        height: 100px;
        img {
          border-radius: 50%;
          width: 100%;
          height: 100%;
        }
      }
    }
  }
  .right-content {
    overflow-y: auto;
    padding: 0 4px;
    @media (min-width: 1199px) {
      padding: 0 20px;
    }
  }
`;
export const HeadHolder = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 0 0 20px;
  h2 {
    margin-bottom: 0;
  }
  .nav-opener {
    width: 35px;
    height: 35px;
    border-radius: 3px;
    background: var(--white);
    border: 1px solid ${({ theme }) => theme?.light?.primary};
    border-radius: 5px;
    flex-shrink: 0;
    position: relative;
    @media (min-width: 1200px) {
      display: none;
    }
    &:before,
    &:after,
    span {
      background: ${({ theme }) => theme?.light?.primary};
      border-radius: 4px;
      position: absolute;
      top: 50%;
      left: 25%;
      right: 25%;
      height: 4px;
      margin-top: -2px;
      transition: all 0.2s linear;
    }
    &:before,
    &:after {
      content: "";
      top: 30%;
    }
    &:after {
      top: 70%;
    }
    .activeSettingSideBar & {
      span {
        opacity: 0;
      }
      &:after,
      &:before {
        transform: rotate(45deg);
        top: 50%;
        left: 15%;
        right: 15%;
      }
      &:after {
        transform: rotate(-45deg);
      }
      &:hover {
        opacity: 0.9;
      }
    }
  }
`;
export const ChangePassWrap = styled.div`
  .heading {
    font-size: 16px;
    line-height: 20px;
    color: #707070;
    margin-bottom: 30px;
  }
`;
export const EditProfileWrap = styled.div`
  .image-wrap {
    position: relative;
    max-width: 160px;
    height: 160px;
    margin: 0 auto 30px;
    img {
      border-radius: 50%;
      width: 100%;
      height: 100%;
      object-fit: cover;
      object-position: top;
    }
    .edit-icon {
      cursor: pointer;
      position: absolute;
      bottom: 0;
      right: 5px;
      background-color: ${({ theme }) => theme?.light?.primary};
      width: 32px;
      height: 32px;
      padding: 5px;
      color: #ffffff;
      border-radius: 10px;
    }
  }
`;
export const PrivacyTermsWrap = styled.div`
  font-size: 16px;
  line-height: 20px;
  color: #707070;
  h2 {
    color: var(--text-color);
  }
  p {
    margin-bottom: 30px;
  }
`;

